const parseXML = (xml: string) => Object.fromEntries(
    [...xml.matchAll(/<(\w+)>([^<]*)<\/\1>/g)]
        .map(([, tag, val]) => [tag.toLowerCase(), isNaN(Number(val)) ? val : Number(val)])
);

export async function getStats() {
    let res = await fetch('/api/shoutcast/stats');
    let xml = await res.text();
    let data = parseXML(xml);

    return data;
}

export async function getCurrentSong() {
    const stats = await getStats();
    return stats.songtitle;
}

export function getSongUrl() {
    return '/api/shoutcast/1.html';
}